import React from 'react';
import { useNavigate } from "react-router-dom";
import './TestTimePageStyle.css';

function TestTimePage() {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/Login") 
    };

    return (
        <div className="container">
            <div className="header">
                <h1>Willkommen bei JuniorAlarm!</h1>
            </div>
            <div className="notice">
                <h2>Kostenlose Testalarme</h2>
                <p>Wir freuen uns, Ihnen mitteilen zu können, dass Sie JuniorAlarm jetzt mit 4 kostenlosen Testalarmen ausprobieren können! Nutzen Sie diese Gelegenheit, um alle Funktionen unseres Dienstes ohne Verpflichtungen zu testen.</p>
                <p>Nach den 4 kostenlosen Testalarmen ist eine Bezahlung erforderlich, um weiterhin Zugang zu unserem Service zu erhalten.</p>
                <p>Wir sind überzeugt, dass JuniorAlarm Ihnen wertvolle Dienste leisten wird, und hoffen, dass Sie von unserem Angebot profitieren werden!</p>
            </div>
            <div className="footer">
                <p>&copy; 2024 MBSoftwareSolutions. Alle Rechte vorbehalten.</p>
            </div>
            <div className="inputContainer">
            <input
                className="inputButton"
                type="button"
                onClick={handleClick}
                value={"Verstanden"} />
            </div>
        </div>
    );
}

export default TestTimePage;